import { cn } from '@/lib/utils';

export const Radio = ({
	label,
	onChange,
	checked,
	className = '',
	inputClassName = '',
	labelClassName = '',
	disabled = false,
	id,
	...props
}) => {
	const isChecked = Boolean(checked);

	return (
		<div className={cn('inline-flex items-center gap-x-2', className)}>
			<label
				className={cn('inline-flex items-center gap-2', disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer')}
			>
				<input
					disabled={disabled}
					type="radio"
					onChange={onChange}
					checked={isChecked}
					id={id}
					className={cn('peer hidden', inputClassName)}
					{...props}
				/>
				<span className="relative h-5 w-5 rounded-full peer-focus-visible:ring-2 peer-focus-visible:ring-ring">
					<svg
						className="h-5 w-5"
						viewBox="0 0 20 20"
						aria-hidden="true"
					>
						<circle
							cx="10"
							cy="10"
							r="8"
							fill="var(--card)"
							stroke={isChecked ? 'var(--primary)' : 'var(--border)'}
							strokeWidth="1"
						/>
						{isChecked && (
							<circle
								cx="10"
								cy="10"
								r="5"
								fill="var(--primary)"
							/>
						)}
					</svg>
				</span>
			</label>
			{label && (
				<label
					htmlFor={id}
					className={cn('text-foreground cursor-pointer text-sm', labelClassName)}
				>
					{label}
				</label>
			)}
		</div>
	);
};
